import { useSelector } from "react-redux";
import { ResponseTab } from "../../RFIS/ResponstTab";

export const KnowledgeBase = () => {
  const { client_id, client_secret } = useSelector(
    (state) => state.clientSecrets
  );
  return (
    <div className="w-full ">
      {client_id && client_secret && (
        <ResponseTab
          clientSecrets={{ client_id, client_secret }}
          route={"/knowledge-base?hideNavigation=true"}
          heading={"View Knowledge Base"}
          desc={"knowledge base"}
        />
      )}
    </div>
  );
};
